var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.quote)?_c('tab-list',_vm._l((_vm.quote.children),function(section){return (section.type === "quote_section")?_c('tab',{key:section.id,attrs:{"name":section.title}},[(section.children.length)?_c('sow-looper',{attrs:{"items":section.children}}):_vm._e()],1):_vm._e()}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }